import { MAX_PROFILE_WORKING_DIRECTORY_LENGTH } from "../protocol/profile.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/provider-runtime-context.ts
const providerDispatchRuntimeContextSchema = z$1.strictObject({ providerRuntimeWorkingDirectory: z$1.string().trim().min(1).max(MAX_PROFILE_WORKING_DIRECTORY_LENGTH).refine((value) => !value.includes("\0"), { message: "providerRuntimeWorkingDirectory must not contain NUL bytes" }) });
//#endregion
export { providerDispatchRuntimeContextSchema };

//# sourceMappingURL=provider-runtime-context.js.map